import { render, staticRenderFns } from "./examHisDialog.vue?vue&type=template&id=b96ba5ee"
import script from "./examHisDialog.vue?vue&type=script&lang=js"
export * from "./examHisDialog.vue?vue&type=script&lang=js"
import style0 from "./examHisDialog.vue?vue&type=style&index=0&id=b96ba5ee&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports